/**
 * The Services menu.
 *
 * Labels and slugs are the ones the four service pages were built with — see
 * `src/content/waq/services.ts`. There is no services index page, so the menu
 * has no landing link of its own: on desktop the label is a disclosure button,
 * on mobile it is a heading above the four items.
 */
export type ServiceNavItem = {
  label: string;
  href: string;
  /** One line of orientation under the label, so the menu is scannable. */
  note: string;
};

export const servicesNav: ServiceNavItem[] = [
  {
    label: 'AI-Driven Validation',
    href: '/services/ai-driven-validation',
    note: 'When test design is the bottleneck',
  },
  {
    label: 'Test Architecture & QA Platform Engineering',
    href: '/services/qa-architecture-engineering',
    note: 'When the framework itself is the constraint',
  },
  {
    label: 'QA Consulting & Modernization',
    href: '/services/qa-consulting-modernization',
    note: "When you're not yet sure what's wrong",
  },
  {
    label: 'Intelligent Quality Operations',
    href: '/services/intelligent-quality-operations',
    note: 'When you need the QA function run, not fixed',
  },
];
